import { render, staticRenderFns } from "./AuthBrandPanel.vue?vue&type=template&id=1d500eac&scoped=true"
import script from "./AuthBrandPanel.vue?vue&type=script&lang=js"
export * from "./AuthBrandPanel.vue?vue&type=script&lang=js"
import style0 from "./AuthBrandPanel.vue?vue&type=style&index=0&id=1d500eac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d500eac",
  null
  
)

export default component.exports